class VariantsWithBulk extends HTMLElement {
  constructor() {
    super();

    this.bulkExpander = this.querySelector("[data-bulk-expander]");
    this.bulkOptions = this.querySelector("[data-bulk-options]");
    this.options = this.querySelectorAll("[data-vpwb-option]");
    this.ffOptions = this.querySelectorAll("[data-vpwb-option].vpwb-option--ff");
    this.obOptions = this.querySelectorAll("[data-vpwb-option].vpwb-option--ob");
    this.activeOption = this.querySelector("[data-vpwb-option].selected");
    this.subscribeCheckbox = this.querySelector("[data-subscribe-checkbox]");
    this.deliveryFrequency = this.querySelector("[data-delivery-frequency]");
    this.deliveryFrequencySelectors = this.querySelectorAll("[data-frequency-selector]");
    this.activeDeliveryFrequency = this.querySelector("[data-frequency-selector].selected");

    this.subscribtionSelected = false;

    this.sellingPlanInput = document.querySelector("[data-custom-selling-plan-input]");
    this.variantSelector = document.querySelector("[data-product-select]");
    this.totalPrice = document.querySelector("[js-data-product-total-price]");
  }

  connectedCallback() {
    this.bulkExpander.addEventListener(
      "click",
      this.expandBulkOptions.bind(this)
    );
    this.options.forEach((option) => {
      option.addEventListener(
        "click",
        this.handleOptionSelect.bind(this, option)
      );
    });
    this.subscribeCheckbox.addEventListener('click', this.toggleSubscription.bind(this));
    this.deliveryFrequencySelectors.forEach((selector) => {
      selector.addEventListener('value-changed', this.handleDeliveryFrequencySelectorChange.bind(this));
    })


    // to ensure logic is only active with the test
    let retryCount = 10;
    this.isActive = this.classList.contains("is-active");
    const intervalId = setInterval(() => {
      if(retryCount == 0 || this.isActive) clearInterval(intervalId);
      retryCount--;

      this.isActive = this.classList.contains("is-active");
      if(this.isActive) {
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }
    }, 500);
  }

  clearSellingPlanFormInput() {
    this.sellingPlanInput.value = "";
    this.sellingPlanInput.disabled = true;
  }

  handleDeliveryFrequencySelectorChange(e) {
    this.updateSellingPlanFormInput(e.detail.newValue);
  }

  updateSellingPlanFormInput(sellingPlanId) {
    if(!this.subscribtionSelected) return;
    this.sellingPlanInput.value = sellingPlanId;
    this.sellingPlanInput.disabled = false;
  }

  updateVariantIdFormInput(variantId) {
    const optionToSelect = this.variantSelector.querySelector(`[value='${variantId}']`);
    if(optionToSelect) {
      optionToSelect.selected = true;
    }
  }

  getSelectedIndexFf() {
    return Array.from(this.ffOptions).findIndex(option => option.classList.contains("selected"));
  }
  
  getSelectedIndexOb() {
    return Array.from(this.obOptions).findIndex(option => option.classList.contains("selected"));
  }

  onVariantChange(e) {
    this.classList.remove("ob-selected", "ff-selected");

    if (e.detail.variant.title.includes('Ocean Breeze')) {
      this.classList.add("ob-selected");
      this.selectSizeOb();
    }
    else if(e.detail.variant.title.includes('Fragrance Free')) {
      this.classList.add("ff-selected");
      this.selectSizeFf();
    }

    this.totalPrice.style.display = "none";
    setTimeout(() => {
      this.updateVariantIdFormInput(this.activeOption.dataset.variantId);
      this.updateButtonPrice();
    }, 200);
    this.updateSellingPlanFormInput(this.activeDeliveryFrequency.value);
  }

  updateButtonPrice() {
    const variantPriceEl = this.subscribtionSelected
    ? this.activeOption
        .querySelector(".vpwb-option__price-wrapper--subscription")
        .querySelector(".vpwb-option__price")
    : this.activeOption
        .querySelector(".vpwb-option__price-wrapper--regular")
        .querySelector(".vpwb-option__price");

    this.totalPrice.innerHTML = variantPriceEl.innerHTML;
    this.totalPrice.style.display = "inline";
  }

  selectSizeFf() {
    const index = this.getSelectedIndexOb();
    if(index < 0) return;

    this.ffOptions[index].click();
  }

  selectSizeOb() {
    const index = this.getSelectedIndexFf();
    if(index < 0) return;
    
    this.obOptions[index].click();
  }

  handleOptionSelect(option) {
    this.deselectActiveOption();
    option.classList.add("selected");
    this.activeOption = option;

    this.displayDeliveryFrequency(option.dataset.variantId);
    this.updateVariantIdFormInput(option.dataset.variantId);
    this.updateSellingPlanFormInput(this.activeDeliveryFrequency.value);

    this.totalPrice.style.display = "none";
    this.updateButtonPrice()
  }

  displayDeliveryFrequency(variantId) {
    if(!variantId) return;
    this.deselectActiveFrequency();

    const matchingFrequency = this.querySelector(`[data-frequency-selector][data-variant-id="${variantId}"]`);

    if (matchingFrequency) {
      matchingFrequency.classList.add("selected");
      this.activeDeliveryFrequency = matchingFrequency;
    }
  }

  toggleSubscription() {
    this.subscribtionSelected = !this.subscribtionSelected;
    if(this.subscribtionSelected) {
      this.subscribeCheckbox.classList.add("checked");
      this.expandDeliveryFrequency();
      this.classList.add("subscription-checked");
      this.updateSellingPlanFormInput(this.activeDeliveryFrequency.value);
    }
    else {
      this.subscribeCheckbox.classList.remove("checked");
      this.contractDeliveryFrequency();
      this.classList.remove("subscription-checked");
      this.clearSellingPlanFormInput();
    }
    this.totalPrice.style.display = "none";
    this.updateButtonPrice()
  }

  expandBulkOptions() {
    this.hideExpander();

    this.bulkOptions.style.maxHeight = "250px";
    this.bulkOptions.style.overflow = "visible";
  }

  expandDeliveryFrequency() {
    this.deliveryFrequency.style.maxHeight = "250px";
    this.deliveryFrequency.style.overflow = "visible";
  }

  contractDeliveryFrequency() {
    this.deliveryFrequency.style = "";
  }

  deselectActiveOption() {
    this.activeOption.classList.remove("selected");
  }

  deselectActiveFrequency() {
    this.activeDeliveryFrequency.classList.remove("selected");
  }

  hideExpander() {
    this.bulkExpander.classList.add("hidden-force");
  }

  showExpander() {
    this.bulkExpander.classList.remove("hidden-force");
  }
}

customElements.define("variants-with-bulk", VariantsWithBulk);


// Similar to custom-dropdown
class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector("[data-select]");
    this.optionsWrapper = this.querySelector("[data-options]");
    this.options = this.querySelectorAll("[data-option]");
    this.isOpen = false;
    this.valueElement = this.querySelector("[data-selected-value]");
    if (this.options.length > 0) this.value = this.valueElement.dataset.selectedValue;
    else this.value = "";
  }

  connectedCallback() {
    this.selector.addEventListener("click", () => {
      this.handleSelectClick();
    });

    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        this.selectValue(option);
      });
    });

    if(this.optionsWrapper) {
      this.optionsWrapper.addEventListener("click", () => {
        this.close();
      });
    }
  }

  handleSelectClick() {
    if (this.isOpen) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.isOpen = true;
  }

  close() {
    this.classList.remove("open");
    this.isOpen = false;
  }

  selectValue(option) {
    this.value = option.dataset.value;
    this.valueElement.innerHTML = option.innerHTML;
    this.valueElement.dataset.selectedValue = this.value;
    this.close();

    const event = new CustomEvent("value-changed", {
      detail: {
        newValue: this.value
      }
    });

    this.dispatchEvent(event);
  }
}

customElements.define("custom-select", CustomSelect);